import  './ResponseStatistic.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useRef } from "react";

import { fetchResponse } from "../../slices/statisticSlice";

import { Box } from "@mui/material";

import ReactECharts from "echarts-for-react";

const ResponseStatistic = ({params}) => {
    const dispatch = useDispatch();
    const responseStatistic = useSelector((state) => state.statistic.responseStatistic);
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);
    const chartRef = useRef(null);

    useEffect(() => {
        dispatch(fetchResponse({token, params}));
    }, [dispatch, token, params]);

    useEffect(() => {
        setTimeout(() => {
            chartRef.current?.getEchartsInstance().resize();
        }, 100);
    }, [responseStatistic]);

    const categories = responseStatistic.map(item => item.emergency_type.alias || item.emergency_type.name);
    const responseTimes = responseStatistic.map(item => parseFloat(item.avg_response_time) || 0);

    const options = {
        title: {
            text: 'Распределение времени отклика',
            left: 'center'
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
            formatter: (params) => {
                const { name, value } = params[0];
                return `${name}: ${value} ч`;
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '15%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: categories,
            axisLabel: {
                rotate: 40,
                fontSize: 10
            }
        },
        yAxis: {
            type: 'value',
            name: 'Время (часы)',
            axisLabel: {
                formatter: '{value} ч'
            }
        },
        series: [
            {
                name: 'Среднее время отклика',
                type: 'bar',
                data: responseTimes,
                itemStyle: { color: '#FF5722' }
            }
        ]
    };

    return (
        <Box className="response_statistic">
            <ReactECharts ref={chartRef} option={options} style={{ width: '100%', height: '100%' }} />
        </Box>
    );
};

export default ResponseStatistic;